module.exports = {"610304001":"虢镇街道","610304002":"东关街道","610304003":"千渭街道","610304101":"阳平镇","610304102":"千河镇","610304103":"磻溪镇","610304104":"天王镇","610304105":"慕仪镇","610304106":"周原镇","610304107":"贾村镇","610304109":"县功镇","610304110":"新街镇","610304111":"坪头镇","610304112":"香泉镇","610304113":"赤沙镇","610304114":"拓石镇","610304115":"凤阁岭镇","610304116":"钓渭镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610304.json
// module id = 2588
// module chunks = 0